module.exports = __webpack_public_path__ + "img/kg_kg_02.79dc10ec.png";